import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PersonItem } from '@models/custom-fields.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { StatusBadgeComponent } from '@shared-components/badge/status-badge/status-badge.component';
import { CopyComponent } from '@shared-components/copy/copy.component';

@Component({
  selector: 'ts-person-card',
  templateUrl: './person-card.component.html',
  imports: [CommonModule, StatusBadgeComponent, CopyComponent, TranslationPipe]
})
export class PersonCardComponent {
  @Input() person: PersonItem;
  @Input() card_wrap: boolean = true;
  @Input() clear_enabled: boolean = true;
  @Output() clear: EventEmitter<boolean> = new EventEmitter();

  clearPerson(): void {
    this.clear.emit(true);
  }
}
